import _transform from 'lodash/transform';
import _isEqual from 'lodash/isEqual';
import _isObject from 'lodash/isObject';

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object to represent the diff
 */
function difference(object, base) {
  function changes(object, base) {
    return _transform(object, function(result, value, key) {
      if (!_isEqual(value, base[key])) {
        result[key] = _isObject(value) && _isObject(base[key]) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
}

export default difference;



// WEBPACK FOOTER //
// ./src/utils/objectDifference.js